module.exports = __webpack_public_path__ + "static/media/img_accept.409a3f8f.svg";